//#region components/description_list/description_list_constants.js
var e = ["row", "column"];
//#endregion
export { e as DT_DESCRIPTION_LIST_DIRECTION };

//# sourceMappingURL=description-list-constants.js.map